import React from 'react';
import PropTypes from 'prop-types';
import { gettext } from '@eb/i18n';
import classNames from 'classnames';

import { Button } from '@eb/eds-button';

import ModalMessage from '../ModalMessage';

import './PasswordlessEmailStatus.scss';

const PasswordlessEmailStatus = ({ email, onClick }) => {
    const componentClasses = classNames(
        'eds-l-mar-vert-14 passwordless-email-status',
    );

    const headerText = gettext('Check your email to log in');
    let subtitleText = gettext(
        'We sent your login link to your email address.',
    );

    //Need to conditionally check if the email is present and update copy accordingly
    //in case the user refreshes the notification page and we lose the email from state.
    if (email) {
        subtitleText = (
            <div
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                    __html: gettext(
                        'We sent your login link to <strong>%(email)s</strong>.',
                        {
                            email,
                        },
                    ).toString(),
                }}
            />
        );
    }

    return (
        <div className={componentClasses}>
            <ModalMessage
                headerText={headerText}
                subtitleText={subtitleText}
                email={email}
            />

            <div className="eds-l-pad-top-8 eds-align--center">
                <Button
                    type="button"
                    style="link"
                    onClick={onClick}
                    data-testid="passwordless-ok-button"
                    __containerClassName="passwordless-form__button--grey"
                >
                    {gettext('OK')}
                </Button>
            </div>
        </div>
    );
};

PasswordlessEmailStatus.propTypes = {
    email: PropTypes.string,
};

export default PasswordlessEmailStatus;
